import React, { useContext, useEffect } from 'react';
import AddNewItem from '../../pieces/AddNewItem';
import checkEmptyObject from '../../../../utils/checkEmptyObject';
import { ThemeDispatchContext, ThemeStateContext } from './CreateEditThemeProvider';
import FormInfoTheme from './FormInfoTheme';

const AddNewTheme = () => {
  const {
    state: { errors, items },
    handleSubmit,
    loading,
  } = useContext(ThemeStateContext);
  const dispatch = useContext(ThemeDispatchContext);

  useEffect(() => {
    dispatch({
      type: 'CLEAR_STATE',
    });
  }, [dispatch]);

  return (
    <AddNewItem
      disableSubmit={checkEmptyObject(errors).length > 0}
      items={items}
      loading={loading}
      dispatch={dispatch}
      handleSubmit={handleSubmit}
      msgSubmit="Tem a certeza que deseja gravar o novo tema?"
    >
      <FormInfoTheme />
    </AddNewItem>
  );
};

export default React.memo(AddNewTheme);
